var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoodbye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 305 338"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M280.6 202.3a91.5 91.5 0 10-183 0 91.5 91.5 0 00183 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M101.6 334.7c-8.6 4-19 .3-23-8.3L33 229.2a17.3 17.3 0 1131.3-14.7l45.6 97.2c4 8.6.4 19-8.3 23z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M87.5 335a18.3 18.3 0 01-9-24.3l30.5-65.4a18.3 18.3 0 1133.2 15.5l-30.4 65.4a18.3 18.3 0 01-24.3 8.9z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DAB48C",
    strokeWidth: 0.9,
    d: "M87.5 335a18.3 18.3 0 01-9-24.3l30.5-65.4a18.3 18.3 0 1133.2 15.5l-30.4 65.4a18.3 18.3 0 01-24.3 8.9z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M76.6 241.6l26.2 55.6-26.2-55.6z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M76.6 241.6l26.2 55.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M105.2 332.7l-3.6 2a16.1 16.1 0 01-22.4-7.2L28.6 219.7A17.3 17.3 0 0159.9 205"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9575",
    fillRule: "evenodd",
    d: "M133.3 236.4c-3.6-1.7-7.6-2-11.3-1.3a18.3 18.3 0 0113 25.7l-30.3 65.4a18.3 18.3 0 01-13 10.2 18.3 18.3 0 0020.1-10.2l30.4-65.4c4.3-9.2.3-20.1-8.9-24.4z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M133.3 236.4v0c-3.6-1.7-7.6-2-11.3-1.3a18.3 18.3 0 0113 25.7l-30.3 65.4a18.3 18.3 0 01-13 10.2 18.3 18.3 0 0020.1-10.2l30.4-65.4c4.3-9.2.3-20.1-8.9-24.4z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1D2E8",
    fillRule: "evenodd",
    d: "M124 209.6l-23.3 46.5a4.8 4.8 0 002.6 6.7l40.7 15c1.3.5 2.6 0 3.2-1.2l10-21.5-33.2-45.5z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#87ACCF",
    fillRule: "evenodd",
    d: "M156.7 256.2l-31-42.5-1 3-.3 1.3c-5.5 19.4-8.1 37 1.4 53.1L144 278c1.2.4 2.6-.1 3.2-1.3l9.5-20.4z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1D2E8",
    fillRule: "evenodd",
    d: "M305 254c-9.5-50.5-24.4-53.6-24.5-54.5a163.5 163.5 0 00-69.3-13.4c-14.3 0-28 1.3-40.7 4-17.6 3-33.2 8.8-45.4 18a4 4 0 00-1.5 2.8c-.2 2-.2 4-.2 6v4a84.5 84.5 0 0031.9 66.2 92.5 92.5 0 0034.2 6.7c50.4-.2 115.5 10.6 115.5-39.8z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#87ACCF",
    fillRule: "evenodd",
    d: "M211.2 186.1a198.8 198.8 0 00-51.4 6.2v3c0 13.2 10 30.2 18.4 42a12.7 12.7 0 0018 3c24-18 36.3-33.1 36.3-45v-8.2c-7-.6-14-1-21.3-1z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#283271",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M226.2 39.4a24 24 0 0032-1.5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#535AA4",
    fillRule: "evenodd",
    d: "M257.4 31.9c5.7-9.4 1.8-22.1-8.7-28.4-10.4-6.3-23.5-3.8-29.1 5.6-5.7 9.4-3.9 24 6.6 30.3a24 24 0 0031.2-7.5z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE983",
    fillRule: "evenodd",
    d: "M238.3 48.2c-2.6 5.1-10.5 6.4-17.7 2.7-7.1-3.7-10.7-10.8-8-16 2.6-5.2 10.5-6.4 17.6-2.7 7.2 3.6 10.8 10.8 8.1 16z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#283271",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M223.3 19.6S222.9 5 238.3 4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F8D431",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M237 34.3s3.5 15.2-11.6 19.7m4.8-21.8s-7.7-1.5-13 12m5.7-14.1s-7.1 0-14.5 14"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#283271",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M175.9 170.5a57.3 57.3 0 0074.9-31"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#535AA4",
    fillRule: "evenodd",
    d: "M251.2 109.4l-2.7-20.3c-.4-2.7-1-5.3-1.7-7.9v-.4A61.2 61.2 0 10125.5 97l.5 3.6a56 56 0 0012.4 28.6 57.3 57.3 0 00112.8-19.9z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#283271",
    fillRule: "evenodd",
    d: "M238.5 129.5c1.4-8.5-5.7-16-14.2-14.8-28.6 3.6-89 12.1-84.1 18 6.3 28.9 19.5 48.6 49.3 44.6a57.3 57.3 0 0049-47.8z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M224.2 118.8h-56.5v78c0 12 11.5 29.7 17 37.3a4.6 4.6 0 006.4 1c9.4-6.9 33-25.8 33-38.3v-78z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeWidth: 0.9,
    d: "M224.2 118.8h-56.5v78c0 12 11.5 29.7 17 37.3a4.6 4.6 0 006.4 1c9.4-6.9 33-25.8 33-38.3v-78z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9575",
    fillRule: "evenodd",
    d: "M187.7 228.9a5.6 5.6 0 01-7.3-1l4.2 6.2a4.6 4.6 0 006.5 1c9.4-6.9 33-25.8 33-38.3v-2.7c-3.7 12.3-26.8 28.5-36.4 34.8z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M187.7 228.9a5.6 5.6 0 01-7.3-1s0 0 0 0l4.2 6.2a4.6 4.6 0 006.5 1c9.4-6.9 33-25.8 33-38.3v-2.7c-3.7 12.3-26.8 28.5-36.4 34.8z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#BB9575",
    fillRule: "evenodd",
    d: "M198 167.6l.2-3.5h-30.5v33.2c17-2 30.3-12.1 30.4-29.7z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M198 167.6l.2-3.5h-30.5v33.2c17-2 30.3-12.1 30.4-29.7z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M215.2 114.6c-7.6 0-14-8.2-15.5-15.3-2.2.6-4.4.9-6.7.9-14 0-25.6-7.3-28-20.6h-.1a15.9 15.9 0 00-29.3-5.5 45 45 0 00-3 16v48.2a45.3 45.3 0 0090.6 0v-26a15.8 15.8 0 01-8 2.3z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M132.7 131v7.3c0 25 20.2 45.3 45.3 45.3h0a46 46 0 0020-4.6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M221.6 135.2c-6.4-2.6-9.2-10.8-6.2-18.3 3-7.5 10.7-11.6 17.1-9 6.4 2.6 9.2 10.8 6.1 18.3-3 7.5-10.6 11.6-17 9z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M164.4 128.8l-4.9 11.9 6.4 3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#20150F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M144 107.4s5-3.8 9.9 0m28.2 0s5-3.8 9.9 0m-17.1 45.4s-5 3.8-9.9 0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M167 139.8l1.4-1m64-26.2s-6.4-3.2-10.2 7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M149 122.2a2.7 2.7 0 01-2.8-2.7v-3.3a2.7 2.7 0 115.4 0v3.3c0 1.5-1.2 2.7-2.7 2.7zm38 0a2.7 2.7 0 01-2.7-2.7v-3.3a2.7 2.7 0 115.5 0v3.3c0 1.5-1.2 2.7-2.7 2.7z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#283271",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M149.8 66.4c7.8 0 14.4 5.7 15.6 13.2 2.4 13.3 14.1 20.6 28.1 20.6 0 0 4.6-.3 6.7-.9 1.7 7.1 8 15.3 15.6 15.3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    stroke: "#283271",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.9,
    d: "M173 84.3c4.5 9.4 14.2 11.6 25.4 11.6m48.4-15.1A61.2 61.2 0 00178 28.3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFE983",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M231 131.4a4 4 0 104 4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M23.4 195.4l-3.3 1.5c-1.7.7-3.7 0-4.5-1.8L1.4 162.3a5.2 5.2 0 119.6-4.1L25.2 191c.7 1.7 0 3.7-1.8 4.4z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeWidth: 0.9,
    d: "M23.4 195.4l-3.3 1.5c-1.7.7-3.7 0-4.5-1.8L1.4 162.3a5.2 5.2 0 119.6-4.1L25.2 191c.7 1.7 0 3.7-1.8 4.4z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M32.8 192.5l-3.4 1.1c-1.8.6-3.7-.4-4.3-2.1l-14.5-43.3a5.2 5.2 0 119.9-3.3L35 188.2c.6 1.7-.4 3.7-2.2 4.3z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeWidth: 0.9,
    d: "M32.8 192.5l-3.4 1.1c-1.8.6-3.7-.4-4.3-2.1l-14.5-43.3a5.2 5.2 0 119.9-3.3L35 188.2c.6 1.7-.4 3.7-2.2 4.3z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M42.5 190.1l-3.5 1c-1.8.4-3.7-.7-4.1-2.5l-13.2-51.8a5.2 5.2 0 1110-2.6L45 186c.5 1.8-.6 3.7-2.4 4.1z",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeWidth: 0.9,
    d: "M42.5 190.1l-3.5 1c-1.8.4-3.7-.7-4.1-2.5l-13.2-51.8a5.2 5.2 0 1110-2.6L45 186c.5 1.8-.6 3.7-2.4 4.1z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M52 187.9l-3.5.6c-1.8.4-3.6-.9-4-2.7L36.4 141a5.2 5.2 0 1110.3-2l8.2 44.9c.3 1.8-.9 3.6-2.7 4z",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeWidth: 0.9,
    d: "M52 187.9l-3.5.6c-1.8.4-3.6-.9-4-2.7L36.4 141a5.2 5.2 0 1110.3-2l8.2 44.9c.3 1.8-.9 3.6-2.7 4z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M45.7 166.6c2.5-1.3 5.7 0 6.4 2.8l8.2 32.3A21.3 21.3 0 1119 212.2l-5.3-20.8a9.2 9.2 0 014.7-10.6l27.2-14.2z",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M39.6 228.2c-9.5 0-18.1-6.4-20.5-16l-5.3-20.8a9.3 9.3 0 011.2-7.5M47.6 166c2 0 4 1.3 4.5 3.4l8.2 32.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAB48C",
    fillRule: "evenodd",
    d: "M51.8 194l6-21.9a8.1 8.1 0 0115.7 4.4l-10 35.7a8.1 8.1 0 01-10 5.6",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB9575",
    strokeLinecap: "round",
    strokeWidth: 0.9,
    d: "M51.8 194l6-21.9a8.1 8.1 0 0115.7 4.4l-10 35.7a8.1 8.1 0 01-10 5.6"
  })));
}

export default SvgGoodbye;